 /**
 * v-hasPermi 操作权限处理
 * Copyright (c) 2019 ruoyi
 */
 
import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    //console.log('权限指令 - inserted 执行')
    checkPermission(el, binding)
  },
  update(el, binding) {
    //console.log('权限指令 - update 执行')
    checkPermission(el, binding)
  }
}

function checkPermission(el, binding) {
  const { value } = binding
  const all_permission = "*:*:*";
  const permissions = store.getters && store.getters.permissions;
  
  // console.log('权限检查 - 所需权限:', value)
  // console.log('权限检查 - 用户权限总数:', permissions ? permissions.length : 0)
  // console.log('权限检查 - 是否包含所需权限:', permissions ? permissions.includes(value[0]) : false)
  // console.log('权限检查 - 元素是否在DOM中:', el.parentNode)
  
  if (value && value instanceof Array && value.length > 0) {
    const permissionFlag = value
    const hasPermissions = permissions && permissions.some(permission => {
      // 检查超级管理员权限
      if (all_permission === permission) {
        //console.log('权限检查 - 超级管理员权限通过')
        return true
      }
      // 检查是否有具体权限
      if (permissionFlag.includes(permission)) {
        //console.log('权限检查 - 具体权限通过:', permission)
        return true
      }
      return false
    })

    if (!hasPermissions) {
      //console.log('❌ 权限检查失败 - 移除元素，没有权限:', value[0])
      // 检查元素是否还在DOM中，避免重复移除
      if (el.parentNode) {
        el.parentNode.removeChild(el)
      }
    } else {
     // console.log('✅ 权限检查通过 - 保留元素:', value[0])
      // 如果元素被移除了但权限通过，需要重新插入
      if (!el.parentNode) {
      //  console.log('⚠️ 权限检查 - 元素被移除但权限通过，需要恢复元素')
        // 这里需要找到原来的位置重新插入，但比较复杂
        // 暂时先不处理，因为正常情况下不应该出现这种情况
      }
    }
  } else {
    throw new Error(`请设置操作权限标签值`)
  }
}
